export const STRING = { EMPTY: '' as '' }

export const HTTP_ERROR = {
  BAD_REQUEST: 400
}
